<template>
  <div
    class="alert alert-warning"
    :class="{ 'd-inline-block': inline }"
    role="alert"
  >
    <div class="alert-icon">
      <i class="fas mr-2 fa-bell-exclamation" />
    </div>
    <div class="alert-content">
      <span>{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WarningBox',
  props: {
    title: {
      type: String,
      required: true,
    },
    inline: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style scoped>
.alert-warning {
  background: #fff5e8 0% 0% no-repeat padding-box;
  border: 1px solid #fdac41;
  border-radius: 4px;
  opacity: 1;
}
.alert-icon {
  float: left;
}

.alert-content {
  margin-left: 1.2%;
  width: 100%;
  margin-right: 28px;
}

.alert span {
  text-align: left;
  font: Regular 16px/24px Lato;
  letter-spacing: 0;
  color: #af6708;
  opacity: 1;
}

.fa-bell-exclamation {
  font-size: 18px;
}
</style>
